export const SOLANA_API_URL = "https://api.solscan.io/market?symbol=";